import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { DateRange } from '../../../entities/search/date-range.entity';
import { translateOrDefaultToValue } from '../../../helpers/add-facets-to-filter-form.helper';
import { IsDateRangeQuery, ParseDateRangeQuery } from '../../../helpers/date-range-query-helper';
import { DEFAULT_FORMAT, MONTH_YEAR, YEAR } from '../../../helpers/format-date.helper';

@Injectable()
export class FacetValueTranslationService {
    constructor(
        private readonly translateService: TranslateService,
        private readonly datePipe: DatePipe
    ) {}

    public translateValue(fieldKey: string, value: string): string {
        if (!IsDateRangeQuery(value)) {
            return translateOrDefaultToValue(fieldKey, value, this.translateService);
        }

        const dateRange = ParseDateRangeQuery(value);

        if (Number.isNaN(dateRange.LengthInDays) || dateRange.From === null) {
            return value;
        }

        const format = this.getDateFormat(dateRange);
        return this.datePipe.transform(dateRange.From.Date, format) || value;
    }

    public translateLabel(fieldKey: string): string {
        return translateOrDefaultToValue(fieldKey, 'label', this.translateService);
    }

    private getDateFormat(dateRange: DateRange): string {
        // At least 365 to account for leap years
        if (dateRange.LengthInDays >= 365) {
            return YEAR;
        }
        // At least 28 to account for february
        if (dateRange.LengthInDays >= 28) {
            return MONTH_YEAR;
        }
        return DEFAULT_FORMAT;
    }
}
